<template>
  <div class="fixed-bottom-left">
    <slot />
  </div>
</template>

<script>
/**
 * @description 画面左下に固定したい場合のコンポーネント
 */
export default {

}
</script>

<style lang="scss" scoped>
.fixed-bottom-left {
  z-index: 100;
  position: fixed;
  bottom: calc(env(safe-area-inset-bottom) + 80px);
  // leftを指定しないと親要素の中で固定される
}
</style>